import React from 'react';
import PageRenderer from '../../components/common/PageRenderer';

function DefaultContent() {
  return (
    <>
      <section className="relative overflow-hidden bg-[#0B5D1E]" style={{ backgroundImage: 'linear-gradient(135deg, #0B5D1E 0%, #094A18 100%)' }}>
        <div className="relative" style={{ paddingTop: 80, paddingBottom: 80, zIndex: 1 }}>
          <div className="max-w-5xl mx-auto px-4 text-center">
            <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 700, color: '#fff', marginBottom: 16, fontFamily: "'Playfair Display',serif" }}>
              Constitution
            </h1>
            <p className="text-white/70 text-lg max-w-2xl mx-auto">
              The governing document of the Nigerian Institution of Surveyors, FCT Branch
            </p>
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display',serif" }}>NIS FCT Branch Constitution</h2>
          <p className="text-gray-600 leading-relaxed mb-6">
            The constitution sets out the rules, regulations, and guiding principles for the administration and governance of the Nigerian Institution of Surveyors, FCT Branch. It defines the objectives, membership criteria, organizational structure, and operating procedures of the branch.
          </p>
          <p className="text-gray-600 leading-relaxed mb-6">
            This constitution was adopted in accordance with the bye-laws of the Nigerian Institution of Surveyors (NIS) and governs all activities of the FCT Branch. All members are bound by the provisions contained herein.
          </p>
        </div>
      </section>

      {/* Key Provisions */}
      <section className="py-16 bg-[#F8FAFB]">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-gray-900 mb-10 text-center" style={{ fontFamily: "'Playfair Display',serif" }}>Key Provisions</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { num: '01', title: 'Objectives', desc: 'The objectives of the branch include promoting the science and practice of surveying, fostering unity among members, and upholding professional ethics.' },
              { num: '02', title: 'Membership', desc: 'Membership is open to all registered surveyors in the FCT who are members of the Nigerian Institution of Surveyors at the national level.' },
              { num: '03', title: 'Governance', desc: 'The branch is governed by an Executive Council elected by members at the Annual General Meeting (AGM) for a specified tenure.' },
              { num: '04', title: 'Meetings', desc: 'The branch holds regular monthly meetings, quarterly reviews, and an Annual General Meeting where elections and major decisions take place.' },
              { num: '05', title: 'Finances', desc: 'The financial affairs of the branch are managed by the Treasurer and Financial Secretary, with audited accounts presented at the AGM.' },
              { num: '06', title: 'Amendments', desc: 'Amendments to this constitution may be proposed by any member and require a two-thirds majority vote at a general meeting.' },
            ].map((item) => (
              <div key={item.num} className="bg-white rounded-xl p-6 border border-gray-100 shadow-sm">
                <span className="inline-block w-10 h-10 rounded-lg bg-[#0B5D1E] text-white text-sm font-bold flex items-center justify-center mb-4">{item.num}</span>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Download / Contact */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <div className="bg-[#F8FAFB] rounded-2xl p-8 md:p-12 border border-gray-100">
            <div className="w-16 h-16 rounded-full bg-[#0B5D1E]/10 flex items-center justify-center mx-auto mb-6">
              <svg className="w-8 h-8 text-[#0B5D1E]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Playfair Display',serif" }}>Need the Full Document?</h3>
            <p className="text-gray-500 mb-6 max-w-md mx-auto">
              For a complete copy of the NIS FCT Branch Constitution, please contact the branch secretariat or request a copy at the next general meeting.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default function Constitution() {
  return <PageRenderer pageKey="constitution" fallback={<DefaultContent />} />;
}
